import { useLocation } from 'react-router-dom';
import { isEmpty, isNil } from 'lodash-es';
import { parse } from 'query-string';

import { JourneyStatus } from '@dev/ee-api/ee-api-models';
import { DEFAULT_OFFSET, DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { GetAutomationsParams } from '@/services/ElasticApi';

export const useRequestParams = (defaultStatuses: JourneyStatus[]): GetAutomationsParams => {
    const location = useLocation();

    const query = parse(location.search, { parseBooleans: true });

    const limit = query?.perPage ? +query.perPage : DEFAULT_PER_PAGE_COUNT;
    const offset = query?.page ? +query.page * limit - limit : DEFAULT_OFFSET;
    const from = isNil(query?.from) ? null : (query?.from as string);
    const to = isNil(query?.to) ? null : (query?.to as string);
    const search = isNil(query?.search) ? null : (query?.search as string);
    const statuses = (query?.statuses ?? []) as JourneyStatus[];

    return {
        from,
        to,
        statuses: isEmpty(statuses[0]) ? defaultStatuses : statuses,
        name: search,
        limit,
        offset,
    };
};
